import { useState, useEffect } from 'react';

interface ReviewsProps {
  onOpenReviewModal: () => void;
}

export default function Reviews({ onOpenReviewModal }: ReviewsProps) {
  const [reviews] = useState([
    {
      name: 'Rajesh Kumar',
      rating: 5,
      text: 'Bahut achha kaam karte hain. Mera ceiling fan bilkul theek ho gaya. Reasonable price bhi liya.',
      date: '2 weeks ago'
    },
    {
      name: 'Priya Sharma',
      rating: 5,
      text: 'Sunil ji ne mera LED bulb aur iron dono theek kar diye. Bahut imandaar aur experienced hain.',
      date: '1 month ago'
    },
    {
      name: 'Amit Singh',
      rating: 5,
      text: 'Local shop hai aur bharosemand bhi. Mobile charger repair karwaya tha, ekdum perfect kaam kiya.',
      date: '3 weeks ago'
    },
    {
      name: 'Sunita Devi',
      rating: 4,
      text: 'Achhi service hai. Pehle testing karte hain phir repair karte hain. Charges bhi reasonable hain.',
      date: '1 week ago'
    },
    {
      name: 'Vikram Yadav',
      rating: 5,
      text: '20 saal ka anubhav dikh jaata hai kaam mein. Speaker repair karwaya tha, ekdum naya jaisa ho gaya.',
      date: '2 months ago'
    },
    {
      name: 'Meena Gupta',
      rating: 5,
      text: 'Bahut achhe se samjhate hain kya problem hai. BP machine theek karwa ke bahut khush hoon.',
      date: '3 weeks ago'
    }
  ]);

  const [averageRating, setAverageRating] = useState(0);

  useEffect(() => {
    const total = reviews.reduce((sum, review) => sum + review.rating, 0);
    setAverageRating(total / reviews.length);
  }, [reviews]);

  const renderStars = (rating: number) => {
    return (
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <i 
            key={star}
            className={`${star <= rating ? 'ri-star-fill text-yellow-400' : 'ri-star-line text-gray-300'} text-lg`}
          ></i>
        ))}
      </div>
    );
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Customer Reviews
          </h2>
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="flex gap-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <i 
                  key={star}
                  className={`${star <= Math.round(averageRating) ? 'ri-star-fill text-yellow-400' : 'ri-star-line text-gray-300'} text-2xl`}
                ></i>
              ))}
            </div>
            <span className="text-2xl font-bold text-gray-900">{averageRating.toFixed(1)}</span>
            <span className="text-gray-600">({reviews.length} reviews)</span>
          </div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Dekhen hamare satisfied customers kya kehte hain
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {reviews.map((review, index) => (
            <div 
              key={index}
              className="bg-gray-50 p-6 rounded-xl border border-gray-200 hover:border-orange-200 hover:shadow-lg transition-all duration-300"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-full text-white font-semibold text-lg">
                    {review.name.charAt(0)}
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">{review.name}</h4>
                    <p className="text-xs text-gray-500">{review.date}</p>
                  </div>
                </div>
              </div>
              
              <div className="mb-3">
                {renderStars(review.rating)}
              </div>
              
              <p className="text-gray-700 text-sm leading-relaxed">
                {review.text}
              </p>
            </div>
          ))}
        </div>
        
        <div className="text-center">
          <button
            onClick={onOpenReviewModal}
            className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-edit-line mr-2"></i>
            Apna Review Dein
          </button>
        </div>
      </div>
    </section>
  );
}
